// resource毎に表示が結構異なりそうなので、Rowをcomponentで切り出して、
// resourceごとの個別要件に対応しやすいようにしておく。

// custom
import NitoelHelpIcon from "components/atoms/NitoelHelpIcon";

// mui
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";

type SpecificPermissionProps = {
  handleChange: () => void;
  checked: boolean;
  label: string;
  helpKey: string;
  disabled?: boolean;
};

export const SpecificPermission: React.FC<SpecificPermissionProps> = (props) => {
  const { handleChange, checked, label, helpKey, disabled = false } = props;

  return (
    <Box>
      <FormControlLabel label={label} control={<Checkbox checked={checked} onChange={handleChange} disabled={disabled} />} />
      <NitoelHelpIcon resource="role" helpKey={helpKey} />
    </Box>
  );
};

export const PermissionCheckBox = ({
  permissions,
  resourceKey,
  permission,
  togglePermission,
  disabled = false,
}: {
  permissions: any;
  resourceKey: string;
  permission: string;
  togglePermission: (resource_key: string, permission_key: string) => void;
  disabled?: boolean;
}): React.JSX.Element => {
  if (permissions?.[resourceKey]?.[permission] === undefined) return <Stack ml={2.5}>-</Stack>;

  return (
    <Checkbox
      checked={permissions[resourceKey][permission] === 1}
      onChange={() => togglePermission(resourceKey, permission)}
      disabled={disabled}
    />
  );
};
